export default {
    'ERROR-SEND-LOGIN': {
        'ERROR-LOGIN-MULTIPLE-USERS': {
            actionType: '',
            message: {
                fr: "Plusieurs utilisateurs trouvés avec cet e-mail.",
                en: 'Multiple users found with this email.',
            },
        },
        'USER-NOT-FOUND': {
            actionType: '',
            message: {
                fr: "Utilisateur non trouvé.",
                en: 'User not found.',
            },
        },
        'ERROR-LOGIN-NO-ADMIN-NO-HELPER-NO-HELPEE': {
            actionType: '',
            message: {
                fr: "L'utilisateur n'est ni administrateur, ni aidant, ni aidé.",
                en: 'User is neither admin, helper, nor helpee.',
            },
        },
        'ERROR-LOGIN-ADMIN-HELPER-HELPEE': {
            actionType: '',
            message: {
                fr: "L'utilisateur est à la fois administrateur, aidant et aidé. Veuillez sélectionner un rôle spécifique.",
                en: 'User is both admin, helper, and helpee. Please select a specific role.',
            },
        },
    },
};
